import type { StarType } from '@galaxis/shared';

export const SHIP_CLASS_LABELS: Record<string, string> = {
  scout: 'Felderítő',
  construction: 'Építő',
  corvette: 'Korvett',
  frigate: 'Fregatt',
  cruiser: 'Cirkáló',
};

export const STAR_TYPE_LABELS: Record<StarType, string> = {
  yellow_dwarf: 'Sárga törpe',
  red_dwarf: 'Vörös törpe',
  blue_giant: 'Kék óriás',
  white_dwarf: 'Fehér törpe',
  neutron_star: 'Neutroncsillag',
  black_hole: 'Fekete lyuk',
  binary: 'Kettős rendszer',
};

export const STAR_TYPE_COLORS: Record<StarType, string> = {
  yellow_dwarf: '#ffd700',
  red_dwarf: '#ef5350',
  blue_giant: '#4fc3f7',
  white_dwarf: '#e0e0e0',
  neutron_star: '#ce93d8',
  black_hole: '#78909c',
  binary: '#ffcc02',
};

export const DISCOVERY_LABELS = {
  unknown: 'Ismeretlen',
  detected: 'Meglátogatva',
  surveyed: 'Feltérképezve',
  colonized: 'Gyarmatosítva',
};
